import { ProviderPortalFeatureFlagKey } from './providerPortalFeatureFlags';
import { useFeatureFlags } from './FeatureFlagProvider';

/**
 * Returns whether a Provider Portal feature flag is enabled.
 *
 * Defaults to {@code false} while flags are still loading or if the key is unknown,
 * which is the safe default for new features.
 */
export const useFeatureFlag = (key: ProviderPortalFeatureFlagKey): boolean => {
    const { flags } = useFeatureFlags();
    return flags[key] ?? false;
};
